(function () {
  var API = 'https://api.reviews.io/';

  function endpoint(store, includeProducts, lang) {
    if (includeProducts) {
      return API + 'timeline/data?type=store_review&store=' + encodeURIComponent(store) +
        '&sort=date_desc&page=1&per_page=1&enable_avatars=false&include_subrating_breakdown=1' +
        '&must_have_comments=true&branch=&tag=&include_product_reviews=1&sku=&lang=' + encodeURIComponent(lang);
    }

    return API + 'merchant/rating?store=' + encodeURIComponent(store);
  }

  function parse(json, includeProducts) {
    if (!json) {
      return null;
    }

    if (includeProducts) {
      if (!json.stats) {
        return null;
      }
      return { value: json.stats.average_rating, count: json.stats.review_count };
    }

    if (!json.rating) {
      return null;
    }

    return { value: json.rating.rating, count: json.rating.total };
  }

  function fill(element, data) {
    var label = element.querySelector('[data-rating-label]');
    var lang = document.documentElement.lang || 'de';
    var number = Number(data.value);
    var formatted = isNaN(number)
      ? data.value
      : number.toLocaleString(lang, { minimumFractionDigits: 1, maximumFractionDigits: 2 });
    var word = element.dataset.reviewsWord || '';

    if (label) {
      label.textContent = (formatted + ' · ' + data.count + ' ' + word).trim();
    }

    element.setAttribute('title', (data.count + ' ' + word).trim());
    element.hidden = false;
  }

  function target(element) {
    var selector = element.dataset.reviewsTarget;

    if (selector) {
      try {
        var chosen = document.querySelector(selector);
        if (chosen) {
          return chosen;
        }
      } catch (error) {
        return null;
      }
    }

    return document.querySelector('[id*="reviews_io"]') || document.querySelector('#shopify-product-reviews');
  }

  function bindScroll(element) {
    if (element.dataset.ratingNavigate !== undefined) {
      return;
    }

    element.addEventListener('click', function (event) {
      var destination = target(element);

      if (!destination) {
        return;
      }

      event.preventDefault();
      destination.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function load(element) {
    var store = window.reviewsIoStore || element.dataset.reviewsioStore;

    if (!store) {
      return;
    }

    var includeProducts = element.dataset.reviewsioProducts === '1';
    var lang = window.reviewsIoLang || document.documentElement.lang || 'de';

    fetch(endpoint(store, includeProducts, lang))
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (json) {
        var data = parse(json, includeProducts);

        if (data && data.value && data.count) {
          fill(element, data);
        }
      })
      .catch(function () {});
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rating-live]'), function (element) {
      if (element.dataset.ratingLiveBound) {
        return;
      }

      element.dataset.ratingLiveBound = '1';
      bindScroll(element);
      load(element);
    });
  }

  function scrollToHash() {
    if (window.location.hash !== '#reviews') {
      return;
    }

    var destination = document.querySelector('[id*="reviews_io"]') || document.querySelector('#shopify-product-reviews');

    if (destination) {
      setTimeout(function () {
        destination.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      scrollToHash();
    });
  } else {
    init();
    scrollToHash();
  }

  document.addEventListener('shopify:section:load', init);
})();
